import * as React from 'react';
import { SVGProps } from 'react';

const VisibilityEye = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="40px"
    height="30px"
    viewBox="0 0 500 600"
    xmlns="http://www.w3.org/2000/svg"
    fill="#bbd8f5"
    {...props}
  >
    <path d="M350 443.33c-60.027 0-121.23-28.078-178.16-74.047-41.27-33.332-78.512-75.957-78.512-89.285s37.242-55.953 78.512-89.285c56.922-45.969 118.13-74.047 178.16-74.047s121.23 28.078 178.16 74.047c41.27 33.332 78.512 75.957 78.512 89.285s-37.242 55.953-78.512 89.285C471.238 415.252 410.03 443.33 350 443.33zm0-23.332c53.793 0 110.35-25.941 163.5-68.867 19.977-16.137 38.242-33.801 52.559-50.188 5.894-6.746 10.77-12.898 14.113-17.727 1.844-2.656 3.164-5.152 3.164-3.219s-1.32-.562-3.164-3.219c-3.344-4.828-8.219-10.98-14.113-17.727-14.316-16.387-32.582-34.05-52.559-50.188-53.148-42.926-109.7-68.867-163.5-68.867s-110.35 25.941-163.5 68.867c-19.977 16.137-38.242 33.801-52.559 50.188-5.894 6.747-10.77 12.898-14.113 17.727-1.844 2.657-3.164 5.153-3.164 3.22s1.32.562 3.164 3.218c3.344 4.828 8.219 10.98 14.113 17.727 14.316 16.387 32.582 34.051 52.559 50.188 53.148 42.926 109.7 68.867 163.5 68.867zm0-46.668c-51.547 0-93.332-41.785-93.332-93.332s41.785-93.332 93.332-93.332 93.332 41.785 93.332 93.332S401.547 373.33 350 373.33zm0-23.332c38.66 0 70-31.34 70-70s-31.34-70-70-70-70 31.34-70 70 31.34 70 70 70z" />
  </svg>
);

export default VisibilityEye;
